import { render, staticRenderFns } from "./PageTitleCom.vue?vue&type=template&id=21160488&scoped=true"
var script = {}
import style0 from "./PageTitleCom.vue?vue&type=style&index=0&id=21160488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21160488",
  null
  
)

export default component.exports